import { routes } from "../../routing/routes";
import { ACCESS_RIGHTS_LIMIT, MASTER_ROUTE_MAP, OPERATIONS, SUB_ROUTE_ACCESS } from "./accessRights";
import { getUserAuthorities } from "./Authorization";
import { Authorities } from "./index";

export class AuthenticationService {
    /**
     * getter for authorities
     * @returns {*}
     * @constructor
     */
    get Authorities() {
        return this.authorities;
    }

    /**
     * setter for authorities
     * @param authorities
     * @constructor
     */
    set Authorities(authorities) {
        this.authorities = authorities;
    }

    get IsRefreshing() {
        return this.isRefreshing;
    }
    set IsRefreshing(isRefreshing) {
        this.isRefreshing = isRefreshing;
    }


    /**
     * getter for viewRights
     * @returns {*}
     * @constructor
     */
    get viewRights() {
        return this.VIEW;
    }

    /**
     * setter for viewRights
     * @param viewRights
     * @constructor
     */
    set viewRights(viewRights) {
        this.VIEW = viewRights;

    }

    /**
     *getter for region to be filtered
     * @returns {Array}
     */
    get getRegionToFilter() {
        return this.regionsToFilters;
    }


    constructor(authorities) {
        this.Authorities = authorities;
        this.isRefreshing = false;
        this.isValidUser=true;
        this.subscribers = [];
        this.filterRegionsMap = new Map();
        if (this.Authorities) this.generateViewRightsForRoutes();
    }

    /**
     * returns single instance of service
     * @returns {AuthenticationService}
     */
    static getInstance() {
        if (!this.service) {
            this.service = new AuthenticationService(JSON.parse(getUserAuthorities()));
        }
        return this.service;
    }


    static destroyInstance() {
        this.service = null;
    }

    generateViewRightsForRoutes() {
        let VIEW = {};
        Object.keys(routes).forEach((route) => {
            VIEW[routes[route]] = this.getViewAccessForRoute(routes[route])
        });
        this.viewRights = VIEW;
    }

    getMasterParentRoute() {
        if (this.isManager()) return MASTER_ROUTE_MAP.MANAGER;
        if (this.isCameraMaster()) return MASTER_ROUTE_MAP.CAMERA_MASTER;
        return MASTER_ROUTE_MAP.DEFAULT;
    }

    /**
     * handles  view rights for different routes
     * @param route
     * @returns {boolean}
     */
    getViewAccessForRoute(route) {
        let isAccessible = true;
        
        if (ACCESS_RIGHTS_LIMIT[route] && ACCESS_RIGHTS_LIMIT[route][OPERATIONS.READ]) {
            isAccessible = false;
            for (var i = 0; i < ACCESS_RIGHTS_LIMIT[route][OPERATIONS.READ].length; i++) {
                if (this.Authorities[ACCESS_RIGHTS_LIMIT[route][OPERATIONS.READ][i]]) {
                    isAccessible = true;
                    break;
                }
            }
        }
        
        
        return isAccessible;
    }

    /**
     * checks whether need to filter regions from the all regions on the basis of view permissions and saves result in Map for further use
     * @param route
     * @param operation
     * @returns {boolean}
     */
    shouldFilterRegionFor(route, operation) {
        let mapKey = `${route}_${String(operation)}`;
        let noRegionsToFilters = true;
        this.regionsToFilters = [];
        if (this.filterRegionsMap.get(mapKey)) {
            if (this.filterRegionsMap.get(mapKey).length) {
                noRegionsToFilters = false;
                this.regionsToFilters = [...this.filterRegionsMap.get(mapKey)];
            }
        } else {
            let rolesWhoHasViewRightForRoute;
            if (ACCESS_RIGHTS_LIMIT[route]) {
                rolesWhoHasViewRightForRoute = ACCESS_RIGHTS_LIMIT[route][operation]
            }

            if (rolesWhoHasViewRightForRoute)
                Object.keys(this.Authorities).forEach((value) => {
                    if (value.endsWith('_permissions')) {
                        return;
                    }
                    noRegionsToFilters = noRegionsToFilters && rolesWhoHasViewRightForRoute.indexOf(value) != -1;
                    if (rolesWhoHasViewRightForRoute.indexOf(value) == -1) {
                        this.regionsToFilters = [...this.Authorities[value], ...this.regionsToFilters]
                    }
                });
            this.filterRegionsMap.set(mapKey, this.regionsToFilters);
        }
        return !noRegionsToFilters;

    }

    // getOperationPermissionForRouteAndRegion(route, regionId, operation) {
    //     let rolesWhoHasRight;
    //     let userHasRight = true;
    //     if (ACCESS_RIGHTS_LIMIT[route]) {
    //         rolesWhoHasRight = ACCESS_RIGHTS_LIMIT[route][operation]
    //     }
    //     if (rolesWhoHasRight)
    //         var userAuthorities = Object.keys(this.Authorities);
    //     for (var i = 0; i < userAuthorities.length; i++) {
    //         let userRole = userAuthorities[i];
    //         let userRoleHasRight = rolesWhoHasRight.indexOf(userRole) != -1;
    //         if (!userRoleHasRight) {
    //             if (typeof this.Authorities[userRole] == 'boolean') {
    //                 userHasRight = false;
    //                 break;
    //             }
    //             else {
    //                 if (regionId) {
    //                     userHasRight = (this.Authorities[userRole].indexOf(regionId) == -1);
    //                     if (!userHasRight) {
    //                         break;
    //                     }
    //                 }
    //                 else userHasRight = false;
    //             }
    //
    //
    //         } else {
    //             if (typeof this.Authorities[userRole] == 'boolean') {
    //                 userHasRight = true;
    //             }
    //             else {
    //                 if (regionId)
    //                     userHasRight = this.Authorities[userRole].indexOf(regionId) != -1;
    //                 else {
    //                     userHasRight = false;
    //                 }
    //             }
    //             if (userHasRight) {
    //                 break;
    //             }
    //         }
    //     }
    //
    //     return userHasRight;
    // }

    hasRightForOperationOnRouteInRegion(route, regionId, operation) {
        let rolesWhoHasRight;
        let userHasRight = true;
        if (ACCESS_RIGHTS_LIMIT[route]) {
            rolesWhoHasRight = ACCESS_RIGHTS_LIMIT[route][operation]
        }
        if (rolesWhoHasRight) {
            var userAuthorities = Object.keys(this.Authorities);
            for (var i = 0; i < userAuthorities.length; i++) {
                let userRole = userAuthorities[i];
 
                if (userRole.endsWith('_permissions')) {
                    continue;
                }
                
                let userRoleHasRight = rolesWhoHasRight.indexOf(userRole) != -1;
                if (typeof this.Authorities[userRole] == 'boolean') {
                    userHasRight = userRoleHasRight;
                    if (!userHasRight) {
                        break;
                    }
                } else {
                    if (regionId) {
                        let regionExistsInUserRole = this.Authorities[userRole].indexOf(regionId.toLowerCase()) != -1;

                        /**
                         * implemented XOR operation with not, so final result will be
                         * T  T=  T
                         * T  F=  F
                         * F  T=  F
                         * F  F=  T
                         * @type {boolean}
                         */
                        userHasRight = !(userRoleHasRight ^ regionExistsInUserRole);
                        
                        // Check if operation is WRITE and user has READ-only permission for this specific region
                        if (userHasRight && operation === OPERATIONS.WRITE) {
                            const permissionsKey = `${userRole}_permissions`;
                            const regionPermissions = this.Authorities[permissionsKey];
                            if (regionPermissions && regionPermissions[regionId.toLowerCase()] === 'Read') {
                                userHasRight = false;
                            }
                        }
                        
                        if (regionExistsInUserRole) {
                            break;
                        }
                    } else {
                        userHasRight = false;
                    }

                }
            }
        }
        return userHasRight;
    }

    getViewAccessForSubRoute(path) {
        const allowedRoles = SUB_ROUTE_ACCESS[path];
        if (!allowedRoles) return true;
        return allowedRoles.some(role => this.Authorities[role]);
    }

    shouldShowAll() {
        return this.Authorities && (this.Authorities[Authorities.Admin] || this.Authorities[Authorities.Owner])
    }

    addSubscriber(callback) {
        this.subscribers.push(callback)
    }

    getSubscriber() {
        return this.subscribers;
    }

    setSubscriber(subscribers) {
        this.subscribers = subscribers
    }

    setValidUser(val){
        this.isValidUser=val;
    }
    checkValidUser(){
        return this.isValidUser
    }

    isAdmin() { 
        return JSON.parse(localStorage.getItem('authorities'))[Authorities.Admin];
    }

    isManager(){
        return JSON.parse(localStorage.getItem('authorities'))[Authorities.Manager];
    }

    isCameraMaster(){
        return JSON.parse(localStorage.getItem('authorities'))[Authorities.Camera_Admin];
    }

    isOperation(){
        return JSON.parse(localStorage.getItem('authorities'))[Authorities.Operation];
    }

    isCrutRegion(region){
        return ['BHUBANESWAR','ROURKELA','SAMBALPUR','BERHAMPUR'].includes(region);
    }


    hasWritePermission(role, region) {
        if (!role) return false;
        
        // Admin and Owner always have write permission
        if (this.Authorities[Authorities.Admin] || this.Authorities[Authorities.Owner]) {
            return true;
        }
        
        if (!region) {
            const permissionsKey = `${role}_permissions`;
            const regionPermissions = this.Authorities[permissionsKey];
            if (regionPermissions) {
                return Object.values(regionPermissions).some(permission => permission === 'Write');
            }
            return true;
        }
        
        const permissionsKey = `${role}_permissions`;
        const regionPermissions = this.Authorities[permissionsKey];
        return regionPermissions?.[region?.toLowerCase()] !== 'Read';
    }

    hasAnyWritePermission() {
        if (this.Authorities[Authorities.Admin] || this.Authorities[Authorities.Owner]) {
            return true;
        }
        
        const roles = Object.keys(this.Authorities).filter(key => !key.endsWith('_permissions'));
        for (const role of roles) {
            if (this.hasWritePermission(role)) {
                return true;
            }
        }
        
        return false;
    }

    getUserFirstRegion() {
        if (!this.Authorities) return null;

        if (this.Authorities[Authorities.Admin] || this.Authorities[Authorities.Owner]) {
            return null;
        }

        const roles = Object.keys(this.Authorities).filter(key => !key.endsWith('_permissions'));
        
        for (const role of roles) {
            const roleData = this.Authorities[role];
            if (Array.isArray(roleData) && roleData.length > 0 && roleData[0]) {
                return roleData[0];
            }
        }

        return null;
    }

    getUserRegions() {
        if (!this.Authorities) return [];

        if (this.Authorities[Authorities.Admin] || this.Authorities[Authorities.Owner]) {
            return [];
        }

        const regions = [];
        const roles = Object.keys(this.Authorities).filter(key => !key.endsWith('_permissions'));
        
        for (const role of roles) {
            const roleData = this.Authorities[role];
            if (Array.isArray(roleData)) {
                regions.push(...roleData.filter(r => r));
            }
        }

        return [...new Set(regions)];
    }
}